module.exports = __webpack_public_path__ + "static/img/3.66eb361.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/work/hp-wearable/article/3.jpg
// module id = Y2Ti
// module chunks = 1